// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Fpf9","title":"InfoRow_title__30_oD"};